export default __webpack_public_path__ + "static/media/DCP.9f08d9b0.png";